import React from 'react';
import { useNavigate } from 'react-router-dom';

const Logout: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    localStorage.removeItem('admin');
    localStorage.removeItem('email');
    navigate('/login');
  }, [navigate]);

  return null;
};

export default Logout;
